import React from "react";
import VendorCard from "./VendorCard";
import { V1 } from "../../../../images/Images";
import "./VendorList.css";
import ArrowRightGreenSvg from "../svgs/ArrowRightGreenSvg";

const vendors = [
  {
    image: V1,
    name: "Chucks and Sons Store",
    location: "California",
    deliveryTime: "2 - 3 days",
    rating: 4.9,
    reviews: 100,
  },
  {
    image: V1,
    name: "Alabi Grocery",
    location: "New York",
    deliveryTime: "1 - 2 days",
    rating: 4.7,
    reviews: 85,
  },
  {
    image: V1,
    name: "Fresh Mart",
    location: "Texas",
    deliveryTime: "3 - 4 days",
    rating: 4.8,
    reviews: 120,
  },
];

const VendorList: React.FC = () => {
  return (
    <div className="vendor__list">
      <div className="vendor__list__header">
        <p>Vendors</p>

        <div
          onClick={() => (window.location.href = "/all-vendors")}
          style={{ cursor: "pointer" }}
        >
          <p id="viewall">View all</p> <ArrowRightGreenSvg />
        </div>
      </div>
      <div className="vendor-list">
        {vendors.map((vendor, index) => (
          <VendorCard key={index} {...vendor} />
        ))}
      </div>
    </div>
  );
};

export default VendorList;
